import { FileSource, Message } from "@/types";

import { axios } from "../axios.instance";

export type SendMessageChatRequest = {
  chatId: string;
  isViewOnce: boolean;
  body: string;
  attachments: FileSource[];
};

export type SendMessageChatResponse = Message;

export const sendChatMessage = async (body: SendMessageChatRequest): Promise<SendMessageChatResponse> => {
  const { data } = await axios.post(`/chats/${body.chatId}/messages/text/send`, {
    isViewOnce: body.isViewOnce,
    body: body.body,
    attachments: body.attachments,
  });

  return data;
};
